const ENClassification = {
	"Classificações" : "Classifications",
	"Classificação":"Classification",
	"Adicionar classificação": "Add classification",
	"Alterar classificação": "Change classification",
	"Deseja realmente excluir a classificação": "Do you really want to delete the classification",
	"Erro ao adicionar classificação": "Error on adding classification",
	"Erro ao alterar classificação": "Error on changing classification",
	"Erro ao excluir classificação": "Error on deleting classification",
	"Exclusão de classificação": "Delete classification",
	"Descrição da classificação é requerida": "Classification's description is required",
	"Classificação adicionado com sucesso": "Classification successfully added",
	"classificação alterado com sucesso": "Classification successfully changed",
	"Classificação excluído com sucesso": "Classification successfully deleted",
	"Nova classificação": "New classification"
};

export default ENClassification;
